import React, { useState } from 'react';
import md5 from 'md5';
import { useDispatch } from 'react-redux';

import { Checkbox, FormControlLabel, Grid, Hidden } from '@material-ui/core';

import Typography from '../../componentes/Typography';
import TextField from '../../componentes/TextField';
import Button from '../../componentes/Button';
import Footer from '../../componentes/Footer';
import Logo from '../../componentes/Logo'

import endpoints from '../../configuraciones/endpoints';
import axios, { setTokenHeader } from '../../configuraciones/axios';
import { setUser, STORAGE } from '../../ducks/user';
import { findPropertysEmpty } from '../../utilidades/functions';

import styles from './styles';

const Login = () => {
  const dispatch = useDispatch();
  const classes = styles();
  const [usuario, setUsuario] = useState({ nombreCorto: '', password: '', mantenerSesion: false });
  const [formErrors, setFormErrors] = useState({});

  const handleCheckboxChecked = (e) => {
    let usuarioEstado = usuario;
    usuarioEstado.mantenerSesion = e.target.checked;
    setUsuario(usuarioEstado);
  }

  const btnLogin = (e) => {
    e.preventDefault();
    const { errors, totalErrors } = findPropertysEmpty(document.getElementById('card'), true);

    setFormErrors(errors);

    if (totalErrors === 0) {
      iniciarSesion();
    }
  }

  const iniciarSesion = (e) => {
    let usuarioLogin = {
      nombreCorto: usuario.nombreCorto,
      contrasena: md5(usuario.password),
    };

    axios.post(endpoints.iniciarSesion(), usuarioLogin).then((sesion) => {
      if (usuario.mantenerSesion)
        localStorage.setItem(STORAGE, JSON.stringify(sesion));
      else
        sessionStorage.setItem(STORAGE, JSON.stringify(sesion));

      setTokenHeader(sesion.token);
      dispatch(setUser(sesion));
    })

  }

  return (
    <Grid container className={classes.main}>
      <Grid item xs={12}>
        <Grid container className={classes.body}>
          <Hidden smDown>
            <Grid item md={8} className={classes.contenedorTitulo}>
              <Grid container className={classes.ContenedorTexto}>
                <Grid item xs={12} md={4}>
                  <Typography variant='h4' className={classes.smallText}>Always in</Typography>
                  <Typography variant='h1' className={classes.textocentrado}>TIME</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Grid item xs={12} md={4}>
            <form noValidate onSubmit={btnLogin}>
              <Grid container spacing={1} className={classes.card} id="card">
                <Grid item xs={12}>
                  <h2>INICIO DE SESIÓN</h2>
                  <p>Ingrese sus credenciales para certificarse</p>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justifyContent='center'>
                    <Logo className={classes.logoCheck}/>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name='nombreCorto'
                    placeHolder="Usuario"
                    value={usuario.nombreCorto}
                    onChange={setUsuario}
                    inputProps={{ maxLength: 50, regexonchange: 'true' }}
                    isHandleChange
                    required
                    error={formErrors.nombreCorto}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name='password'
                    placeHolder="Contraseña"
                    type="password"
                    value={usuario.password}
                    onChange={setUsuario}
                    inputProps={{ maxLength: 50, regexonchange: 'true' }}
                    isHandleChange
                    required
                    error={formErrors.password}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel control={
                    <Checkbox
                      name='MantenerSesion'
                      value={usuario.mantenerSesion}
                      onChange={handleCheckboxChecked} />
                  }
                    label="Recordar mis credenciales" />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    name="iniciar"
                    label="Iniciar"
                    classesCustom={{ boton: classes.botonInicio }}
                    isSubmit
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Footer />
      </Grid>
    </Grid >
  );
};

export default Login;
